<script setup>
/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { ref, defineProps, defineExpose } from 'vue';

/*==================================================================*/
/*================== IMPORTS DOS COMPONENTES =======================*/
/*==================================================================*/

import ModalInformacao from '@/components/v2/modais/ModalInformacao/ModalInformacao.vue';

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({
    disabled: {
        type: Boolean,
        default: false
    },
    job: {
        type: Object,
        default: () => ({})
    },
    falhas: {
        type: Array,
        default: () => []
    }
});

/*==================================================================*/
/*================== MODAL REF =====================================*/
/*==================================================================*/

const modalInformacaoRef = ref(null);

/*==================================================================*/
/*================== ABRIR / FECHAR MODAL ===========================*/
/*==================================================================*/

const abrirModal = async () => {

    await modalInformacaoRef.value?.abrirModal();

};

const fecharModal = async () => {

    await modalInformacaoRef.value?.fecharModal();

};

/*==================================================================*/
/*================== EXPOSE ========================================*/
/*==================================================================*/

defineExpose({ abrirModal, fecharModal });

</script>

<template>

    <ModalInformacao
        ref="modalInformacaoRef"
        max-width="600"
        :disabled="props.disabled"
    >

        <template #header>
            Job "{{ props.job?.codigo }}" não pode ser finalizado
        </template>

        <template #body>

            <div>O Job não atende às condições abaixo:</div>

            <ul>
                <li v-for="falha in props.falhas" :key="falha">
                    {{ falha }}
                </li>
            </ul>

        </template>

    </ModalInformacao>

</template>
